import { render } from "./ViewVideo.vue?vue&type=template&id=7da180a5"
import script from "./ViewVideo.vue?vue&type=script&lang=js"
export * from "./ViewVideo.vue?vue&type=script&lang=js"

import "./ViewVideo.vue?vue&type=style&index=0&id=7da180a5&lang=scss"

import exportComponent from "/Users/mohamedyousef/projects/online_education/projects/web-applications/admin-panel-for-education-apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__